import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Skeleton } from '@mantine/core';
import { Context as RegistrationContext } from '../../../providers/RegistrationProvider';
import HeaderView from '../../common/HeaderView';
import { useMediaQueryIndex } from '../../../helpers/hooks';
import { getResponsiveStyle as rs } from '../../../helpers/styles';
import OrderDetailsInfo from './OrderDetailsInfo';
import AppTitle from '../../common/AppTitle';
import AppStack from '../../common/AppStack';
import AppFlexbox from '../../common/AppFlexbox';
import AppCard from '../../common/AppCard';
import AppText from '../../common/AppText';
import SendOrderReceiptModal from '../financials/SendOrderReceiptModal';

const OrderDetailsView = () => {
  const mqIndex = useMediaQueryIndex();
  const { pkRegCart } = useParams();
  const { state, fetchCartOrderHistory } = useContext(RegistrationContext);
  const hasFetched = useRef(false);
  const regCart = state.regCartOrderHistory.value;
  const [receiptModalState, setReceiptModalState] = useState({ isOpen: false });
  const [fetchError, setFetchError] = useState(null);
  const isLoading =
    !fetchError &&
    (!hasFetched.current || state.regCartOrderHistory.loading || !regCart);

  useEffect(() => {
    if (pkRegCart) {
      setFetchError(null);
      fetchCartOrderHistory(pkRegCart, null, (error, type, data, status) =>
        setFetchError({ status: status ?? null })
      );
      hasFetched.current = true;
    }
  }, [pkRegCart]);

  return (
    <HeaderView
      maxViewWidth={1100}
      viewProps={{ gap: rs([10, 10, 20], mqIndex) }}
    >
      {fetchError ? (
        <AppCard style={{ border: 'solid 1px #ced4da' }}>
          <AppStack
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              gap: 10,
              padding: 40
            }}
          >
            <AppText style={{ fontSize: 16 }}>
              {fetchError.status === 404
                ? 'Order not found.'
                : 'We couldn’t load this order.'}
            </AppText>
            <AppText
              component={Link}
              style={{
                fontSize: 14,
                textDecoration: 'none',
                color: 'dodgerblue'
              }}
              to="/orders"
              weight={500}
            >
              Back to order history
            </AppText>
          </AppStack>
        </AppCard>
      ) : !isLoading ? (
        <>
          <AppFlexbox
            style={{ justifyContent: 'space-between', alignItems: 'center' }}
          >
            <AppTitle
              style={{ display: rs(['none', 'none', 'block'], mqIndex) }}
            >
              Order Details
            </AppTitle>
            <Button
              onClick={() =>
                setReceiptModalState({
                  ...receiptModalState,
                  isOpen: true
                })
              }
              style={{
                flex: 1,
                marginTop: rs([10, 10, 0], mqIndex),
                maxWidth: rs(['unset', 'unset', 250], mqIndex)
              }}
            >
              Email Receipt
            </Button>
          </AppFlexbox>

          <OrderDetailsInfo regCart={regCart} showPaymentPlan />
        </>
      ) : (
        <>
          <AppStack style={{ display: rs(['none', 'none', 'block'], mqIndex) }}>
            <Skeleton height={44} width={250} />
          </AppStack>
          <OrderDetailsInfo isLoading />
        </>
      )}
      <SendOrderReceiptModal
        isOpen={receiptModalState.isOpen}
        onClose={() =>
          setReceiptModalState({
            ...receiptModalState,
            isOpen: false
          })
        }
        regCart={regCart}
      />
    </HeaderView>
  );
};

export default OrderDetailsView;
